export const AdminThemeAuditController = {
    index(): void {},
};
